// eslint-disable-next-line no-unused-vars
import React, { createContext, useReducer, useEffect } from 'react';
import _ from 'lodash';
import { Context } from 'shared/types';
import AppReducer from '../reducers/index';
import { loadState, saveState } from './localStorage';

const persistedState = loadState();

const portfolioInitialState = {
    name: '',
    score: 0,
    description: '',
    esgRankings: []
};

export const initialState = {
  rootState: {
    language: { locale: 'EN' },
    masterData: (persistedState && persistedState.rootState && persistedState.rootState.masterData) || null,
    phoneNumber: (persistedState && persistedState.rootState && persistedState.rootState.phoneNumber) || '+65',
    token: (persistedState && persistedState.rootState && persistedState.rootState.token) || '',
    userId: (persistedState && persistedState.rootState && persistedState.rootState.userId) || '',
    error: ''
  },
  investmentState: {
    style: (persistedState && persistedState.investmentState && persistedState.investmentState.style) || '',
    exclusions: (persistedState && persistedState.investmentState && persistedState.investmentState.exclusions) || [],
    environment: (persistedState && persistedState.investmentState && persistedState.investmentState.environment) || [],
    social: (persistedState && persistedState.investmentState && persistedState.investmentState.social) || [],
    governance: (persistedState && persistedState.investmentState && persistedState.investmentState.governance) || [],
    experience: (persistedState && persistedState.investmentState && persistedState.investmentState.experience) || [],
    portfolio: (persistedState && persistedState.investmentState && persistedState.investmentState.portfolio) || portfolioInitialState,
    investHighRanking: (persistedState && persistedState.investmentState && persistedState.investmentState.investHighRanking) || '',
    investMediocreRanking: (persistedState && persistedState.investmentState && persistedState.investmentState.investMediocreRanking) || '',
    groupedSupports: (persistedState && persistedState.investmentState && persistedState.investmentState.groupedSupports) || [],
    threshold: (persistedState && persistedState.investmentState && persistedState.investmentState.threshold) || 2.0,
    carbonRiskScore: (persistedState && persistedState.investmentState && persistedState.investmentState.carbonRiskScore) || 10,
    isCarbonDisabled: (persistedState && persistedState.investmentState && persistedState.investmentState.isCarbonDisabled) || false,
    error: null,
  },
  productState: {
    data: [],
    productsLoaded: [], // (persistedState && persistedState.productState && persistedState.productState.productsLoaded) || 
    isLoading: true,
    paging: {
      total: 0,
      numOfRecords: 0,
    },
    filters: {
      productName: '',
      productRisk: [1,4]
    }
  },
  newsState: {
    data: [],
    searchTerms: [],
    error: null,
  }
};

export const GlobalContext = createContext<Context>({
  state: initialState,
  dispatch: () => {},
});

type Props = {
  children: JSX.Element;
};

export const GlobalProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);
  useEffect(
    _.throttle(() => {
      saveState({
        ...persistedState,
        rootState: state.rootState,
        investmentState: state.investmentState,
        productState: state.productState,
        newsState: state.newsState,
      });
    }, 1000),
    [state]
  );

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};
